/* eslint-disable @typescript-eslint/no-unused-vars */
import { WebPlugin } from '@capacitor/core';
export class RemindersWeb extends WebPlugin {
    requestPermissions() {
        throw new Error('Method not implemented.');
    }
    checkPermissions() {
        throw new Error('Method not implemented.');
    }
    readAll() {
        throw new Error('Method not implemented.');
    }
    write(_) {
        throw new Error('Method not implemented.');
    }
    ;
    delete(_) {
        throw new Error('Method not implemented.');
    }
    ;
}
//# sourceMappingURL=web.js.map